



























































































import { Component, Vue } from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import StatusEffective from '@/components/common/StatusEffective.vue'
import BankAddDialog from './BankDialog.vue'
import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { translate } from '@/utils/filters'
import { statusMap } from '@/utils/status-map'
import { Form } from 'element-ui'

@Component({
    components: {
        SearchForm,
        TableForm,
        StatusEffective,
        BankAddDialog
    },
    filters: {
        Status: (value: number) => {
            if (+value === 0) return translate('bank.invalid')
            else if (+value === 1) return translate('bank.effective')
            else return ''
        }
    }
})
export default class extends Vue {
    formEl: any
    searchForm = {
        current: 1,
        size: 10,
        bankName: null,
        status: null
    }
    statusMap = statusMap
    statusOptions = statusMap.createArray()

    tableLoading = false
    tableData = []
    total = 0

    formProp = {}
    show = false
    disabled = false
    copyShow = false
    formData = {
        sourceMerchantId: '',
        targetMerchantId: ''
    }
    rules = {
        sourceMerchantId: { required: true, message: translate('common.noEmpty'), trigger: 'change' },
        targetMerchantId: { required: true, message: translate('common.noEmpty'), trigger: 'change' }
    }
    form = { bankName: '' }

    onSearchSubmit() {
        this.searchForm.current = 1
        this.getData()
    }

    getData(pageQuery = {}) {
        this.tableLoading = true
        $Api.channelService
            .bankMerchantList(Object.assign(this.searchForm, pageQuery))
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(data => {
                this.tableData = data.list
                this.total = data.total
            })
    }

    copy() {
        this.formData = {
            sourceMerchantId: '',
            targetMerchantId: ''
        }
        this.copyShow = true
    }

    copyClose() {
        ;(this.$refs.dvp as Form).resetFields()
        this.copyShow = false
    }

    copyClick() {
        (this.$refs.dvp as Form).validate(valid => {
            if (!valid) {
                return false
            }
            const form = { ...this.formData }
            Object.keys(form).forEach(key => { form[key] = +form[key] }) // convert to numeric type
            $Api.channelService.copy(form).subscribe(data => {
                this.getData()
                this.$message.success('Success!')
                this.copyShow = false
            }, err => {
                this.$message.error(err.message)
            })
        })
    }

    onCopyDialogClose(done) {
        ;(this.$refs.dvp as Form).resetFields()
        done()
    }

    // 增加
    create() {
        this.show = true
        this.disabled = false
    }

    // 编辑
    modify(row: any) {
        this.formProp = { ...row }
        this.show = true
        this.disabled = false
    }

    // 启用
    bankEnable(row: any) {
        this.showDialog(translate('bank.isBatchEnable'), async () => {
            $Api.channelService
                .batchEnable({ req: row.id })
                .pipe(finalize(this.getData))
                .subscribe()
        })
    }

    // 停用
    bankDisabled(row: any) {
        this.showDialog(translate('bank.isBatchDisable'), async () => {
            $Api.channelService
                .batchDisable({ req: row.id })
                .pipe(finalize(this.getData))
                .subscribe()
        })
    }

    // 弹出提示框
    showDialog(title: string, callback: Function) {
        this.$confirm(title, {
            confirmButtonText: this.$t('common.btn.confirm') as string,
            cancelButtonText: this.$t('common.btn.cancel') as string,
            type: 'warning'
        })
            .then(() => {
                callback()
            })
            .catch(() => {})
    }

    created() {
        this.getData()
    }
}
